// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2k9PM","selects":"Documents_selects__2lOgA"};